<template>
  <transition name="fade" @before-leave="onClose" @after-leave="onDestroy">
    <div class="comp-toast__root" v-show="show">
      <span>{{ message }}</span>
    </div>
  </transition>
</template>

<script lang="ts" setup>
import { ref, toRefs, onMounted} from 'vue';
import type { IToastProps } from './toast-types';
interface Props extends IToastProps {
  message: string;
  duration?: number;
  onDestroy?: () => void;
  onClose?: () => void;
}

const props = withDefaults(defineProps<Props>(), {
  message: '',
  duration: 2000,
  onDestroy: () => {},
  onClose: () => {},
});
const { duration } = toRefs(props);

const show = ref(false);

const close = () => (show.value = false);

let timer = null;

const startTimer = () => {
  if (duration.value > 0) {
    timer = setTimeout(close, duration.value);
  }
};
const stopTimer = () => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
};

onMounted(() => {
  show.value = true;
  startTimer();
});

defineExpose({
  close,
});
</script>

<style scoped lang="less">
.comp-toast__root {
  position: absolute;
  z-index: 2;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-size: 14px;
  padding: 6px 10px;
  border-radius: 4px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
